import { toast } from "vue3-toastify"
import 'vue3-toastify/dist/index.css';

export default function(message,type="error"){
    toast(message,{
        type,
        position:toast.POSITION.TOP_RIGHT,
        pauseOnHover:false,
        autoClose: 6000,
        hideProgressBar: true,
        theme:"auto"
    })
}

